/* wsapi3-identify-flow v1.0 */
/* Deploy Version 2026-10-06 13:31:17 */
/* Deploy Version 2026-09-24 19:11:11 */
/* wsapi3-identify-flow — lógica compartilhada da tela de identificação (e-mail/CPF ->
   senha, login social com retorno de cliente novo para cadastro, esqueci-senha em 3 passos,
   toggle de olho nos campos de senha) usada por wsapi3-login-page, wsapi3-login-sidebar
   e a tela de identificação de wsapi3-checkout-payment-page — as três telas têm
   praticamente a mesma interface/regras, só o HTML/CSS e alguns detalhes (o que
   acontece quando o e-mail não existe, se o botão se move entre linhas, etc.) mudam.

   Expõe window.WsIdentifyFlow.create(config), no mesmo padrão de window.WsCheckoutBase
   (etapa "*", carregado globalmente em GERAL.js — ver project-css-bundled-globally na
   memória do projeto pro equivalente em CSS): cada consumidor só cuida do próprio
   HTML/CSS e passa os seletores + hooks que diferem entre as três telas.

   config = {
     els: {
       // Seletores CSS (qualquer um: '#id' ou '[data-attr="x"]') — todos opcionais
       // exceto os da etapa de identificação em si.
       identityRow, identityInput,              // linha com o campo de e-mail/CPF
       displayRow, displayValue, changeIdentityLink, // texto fixo + "Trocar" (pós-identificação)
       passwordField, passwordRow, passwordInput,    // passwordRow só é usado se moveButton
       continueBtn, continueLabel, mainMsg,
       title, subtitle,                          // opcionais — título/subtítulo trocam de texto
       googleBtn, facebookBtn,
       forgotLink, screenMain,                   // presença de forgotLink liga o fluxo de esqueci-senha
       screenForgot, forgotEmail, forgotMsg, forgotSendBtn, forgotBackBtn,
       screenVerify, verifyEmailLabel, verifyCode, verifyMsg, verifyBtn, verifyBackBtn,
       screenReset, resetPassword, resetPasswordConfirm, resetMsg, resetBtn,
     },
     moveButton: bool,             // true: botão "Continuar/Entrar" se move pra linha da senha
                                    // (login-page, checkout); false: fica fixo (sidebar empilhada)
     socialSignupFallback: bool,   // default true — aceita not_found com e-mail para cadastro
                                    // (ver onSocialSignupResolved), sem uma segunda autorização
     prefillIdentityFromQuery: 'nome-do-query-param' | null,

     // Hooks — todos chamados com o estado já consistente internamente.
     onIdentityNew(identity),           // e-mail/CPF não cadastrado
     onLoginSuccess(record),            // login (senha ou social) concluído
     onSocialSignupResolved(provider, data), // só chamado se socialSignupFallback
     onCheckIdentityError(err),         // opcional — default mostra msg genérica
   }

   Retorna { init(), reset() } — init() liga os eventos uma vez; reset() volta pra
   etapa de identificação do zero (campo limpo, tela principal) — usado por telas que
   reabrem o mesmo formulário várias vezes na mesma página (a sidebar, a cada open()). */
(function () {
  'use strict';

  var SOCIAL_LOGIN_URLS = {
    google: 'https://sistemas-api.webstore.net.br/aplicacoes/google/signin/index.aspx',
    facebook: 'https://sistemas-api.webstore.net.br/aplicacoes/facebook/signin/index.aspx',
  };
  var SOCIAL_LOGIN_LABELS = { google: 'Google', facebook: 'Facebook' };
  var SOCIAL_LOGIN_MAX_WAIT_MS = 5 * 60 * 1000;

  var EYE_ICON = '<svg viewBox="0 0 24 24" fill="none"><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/><circle cx="12" cy="12" r="3" stroke="currentColor" stroke-width="1.6"/></svg>';
  var EYE_OFF_ICON = '<svg viewBox="0 0 24 24" fill="none"><path d="M3 3l18 18M10.6 10.6a3 3 0 0 0 4.24 4.24M9.9 4.24A10.94 10.94 0 0 1 12 4c7 0 11 7 11 7a13.2 13.2 0 0 1-3.15 3.9M6.1 6.1A13.29 13.29 0 0 0 1 11s4 7 11 7a10.9 10.9 0 0 0 5.1-1.24" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  // Espera o markup .wscb-password-wrap > input + [data-wsjs-password-toggle]
  // (ver wsapi3-checkout-base.css).
  function bindPasswordToggle(input) {
    var btn = input && input.parentElement && input.parentElement.querySelector('[data-wsjs-password-toggle]');
    if (!input || !btn || btn.dataset.bound) return;
    btn.dataset.bound = '1';
    btn.innerHTML = EYE_ICON;
    btn.addEventListener('click', function () {
      var show = input.type === 'password';
      input.type = show ? 'text' : 'password';
      btn.innerHTML = show ? EYE_OFF_ICON : EYE_ICON;
      btn.setAttribute('aria-label', show ? 'Ocultar senha' : 'Mostrar senha');
    });
  }

  function detectIdentity(raw) {
    var trimmed = (raw || '').trim();
    if (!trimmed) return null;
    if (trimmed.indexOf('@') !== -1) {
      return /\S+@\S+\.\S+/.test(trimmed) ? { type: 'email', field: 'email', value: trimmed } : null;
    }
    var digits = trimmed.replace(/\D/g, '');
    if (digits.length === 11 || digits.length === 14) {
      return { type: 'cpf_cnpj', field: 'cpf_cnpj', value: digits };
    }
    return null;
  }

  // A página de entrada (StartLogin, do lado do sistemas-api) exige lv_id na query string
  // pra saber de qual loja veio o clique — sem isso ela responde 400 antes de chegar no provedor.
  //
  // return_origin: origin (scheme+host) da janela atual. O backend assina esse valor junto do
  // resto do state e, no callback, só o respeita se o host for um domínio cadastrado da loja
  // ou subdomínio dele — aí o redirect final (/auth-pass, /cadastro-pass e URLs de erro) volta
  // pra essa origin em vez do domínio canônico. Serve pro fluxo de preview de layout, em que o
  // comprador navega num subdomínio (ex.: https://21903-458790815.mbastos.com.br) apontado pra
  // outro servidor; sem isso o login voltaria pro domínio oficial e a sessão se perderia. No
  // domínio oficial o valor casa com ele mesmo e nada muda; valor ausente/inválido é ignorado
  // (fail-safe), então mandar sempre é seguro. Só a origin pura — sem path/query/porta custom.
  function buildSocialAuthUrl(provider, extraParams) {
    var baseUrl = SOCIAL_LOGIN_URLS[provider];
    if (!baseUrl) return '';
    var lvId = (document.getElementById('HD_LV_ID') || {}).value || '';
    var returnOrigin = (window.location && window.location.origin) || '';
    var params = Object.assign(
      {},
      lvId ? { lv_id: lvId } : {},
      returnOrigin ? { return_origin: returnOrigin } : {},
      extraParams || {},
    );
    var query = Object.keys(params)
      .map(function (key) { return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]); })
      .join('&');
    return baseUrl + (query ? '?' + query : '');
  }

  // Abre um popup pra um fluxo social (login ou cadastro) e cuida do ciclo de vida comum:
  // escuta postMessage da mesma origem vindo de /auth-pass ou /cadastro-pass, e faz polling
  // de popup.closed como fallback (bloqueio de popup, COOP cortando window.opener no meio
  // do caminho, etc.). onMessage recebe event.data quando uma mensagem com o `source`
  // esperado chega; onClosed dispara se o popup fechar sem nenhuma mensagem válida ter
  // chegado antes. Só um dos dois roda, o que vier primeiro "resolve" o fluxo.
  function openSocialPopup(url, messageSource, onMessage, onClosed) {
    var width = 480;
    var height = 620;
    var left = window.screenX + Math.max(0, (window.outerWidth - width) / 2);
    var top = window.screenY + Math.max(0, (window.outerHeight - height) / 2);

    var popup = window.open(url, 'ws-social-popup', 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top);

    if (!popup) {
      // Popup bloqueado pelo navegador: cai no fluxo de página inteira
      window.location.href = url;
      return;
    }

    var settled = false;
    var pollTimer = null;
    var maxWaitTimer = null;

    function cleanup() {
      window.removeEventListener('message', onMessageEvent);
      if (pollTimer) clearInterval(pollTimer);
      if (maxWaitTimer) clearTimeout(maxWaitTimer);
    }

    function onMessageEvent(event) {
      if (settled) return;
      if (event.origin !== window.location.origin) return;
      if (event.source !== popup) return;
      if (!event.data || event.data.source !== messageSource) return;
      settled = true;
      cleanup();
      onMessage(event.data);
    }

    window.addEventListener('message', onMessageEvent);

    pollTimer = setInterval(function () {
      if (settled) return;
      if (popup.closed) {
        settled = true;
        cleanup();
        onClosed();
      }
    }, 400);

    maxWaitTimer = setTimeout(function () {
      if (settled) return;
      settled = true;
      cleanup();
      onClosed();
    }, SOCIAL_LOGIN_MAX_WAIT_MS);
  }

  function create(config) {
    config = config || {};
    var els = config.els || {};
    var moveButton = !!config.moveButton;
    var socialSignupFallback = config.socialSignupFallback !== false;

    var identity = null; // { type: 'email'|'cpf_cnpj', field, value }
    var step = 'identity'; // 'identity' | 'password'
    var forgotEmail = '';
    var resetToken = '';
    var identityTitleText = '';

    function $(key) {
      var sel = els[key];
      return sel ? document.querySelector(sel) : null;
    }

    function setMsg(key, text, type) {
      var el = $(key);
      if (!el) return;
      el.textContent = text || '';
      el.className = 'wscb-msg' + (type ? ' wscb-msg--' + type : '');
    }

    function setLoading(key, loading) {
      var btn = $(key);
      if (!btn) return;
      btn.disabled = loading;
      btn.dataset._label = btn.dataset._label || btn.textContent;
      btn.textContent = loading ? 'Aguarde...' : btn.dataset._label;
    }

    function setContinueLabel(text) {
      var lbl = $('continueLabel');
      if (lbl) lbl.textContent = text;
    }

    function showScreen(key) {
      ['screenMain', 'screenForgot', 'screenVerify', 'screenReset'].forEach(function (k) {
        var el = $(k);
        if (el) el.style.display = k === key ? '' : 'none';
      });
    }

    // Volta pra etapa de identificação sem apagar o que já estava digitado no campo
    // (usado pelo link "Trocar" — a pessoa só quer corrigir o que digitou, não
    // recomeçar do zero).
    function goBackToIdentityStep() {
      step = 'identity';
      identity = null;

      var identityRow = $('identityRow');
      var displayRow = $('displayRow');
      var passField = $('passwordField');
      var passInp = $('passwordInput');
      var title = $('title');
      var subtitle = $('subtitle');
      var identityInp = $('identityInput');

      if (identityRow) identityRow.style.display = '';
      if (displayRow) displayRow.style.display = 'none';
      if (passField) passField.style.display = 'none';
      if (passInp) passInp.value = '';
      if (moveButton) {
        var continueBtn = $('continueBtn');
        if (identityRow && continueBtn) identityRow.appendChild(continueBtn);
      }
      if (title) title.textContent = identityTitleText;
      if (subtitle) subtitle.style.display = '';
      setContinueLabel('Continuar');
      setMsg('mainMsg', '', '');
      if (identityInp) identityInp.focus();
    }

    // Reset completo (limpa também o campo de identidade e volta pra tela principal) —
    // usado por quem reabre o mesmo formulário do zero (a sidebar, a cada open()).
    function resetToIdentityStep() {
      goBackToIdentityStep();
      var identityInp = $('identityInput');
      if (identityInp) identityInp.value = '';
      showScreen('screenMain');
    }

    // Revela o campo de senha (conta já existente/confirmada): esconde o campo de
    // e-mail/CPF e mostra o valor confirmado como texto fixo (ver goBackToIdentityStep
    // pro "Trocar"). Quando moveButton, o botão desce pra linha da senha.
    function revealPasswordStep() {
      step = 'password';

      var identityRow = $('identityRow');
      var displayRow = $('displayRow');
      var displayValue = $('displayValue');
      var passField = $('passwordField');
      var passInp = $('passwordInput');
      var title = $('title');
      var subtitle = $('subtitle');

      if (identityRow) identityRow.style.display = 'none';
      if (displayRow) displayRow.style.display = '';
      if (displayValue) displayValue.textContent = identity ? identity.value : '';
      if (passField) passField.style.display = '';
      if (moveButton) {
        var passRow = $('passwordRow');
        var continueBtn = $('continueBtn');
        if (passRow && continueBtn) passRow.appendChild(continueBtn);
      }
      if (title) title.textContent = 'Informe sua senha';
      if (subtitle) subtitle.style.display = 'none';
      setContinueLabel('Entrar');
      if (passInp) passInp.focus();
    }

    async function checkIdentityAndProceed() {
      var identityInp = $('identityInput');
      var continueBtn = $('continueBtn');
      var raw = (identityInp || {}).value || '';
      setMsg('mainMsg', '', '');

      var found = detectIdentity(raw);
      if (!found) {
        setMsg('mainMsg', 'Informe um e-mail ou CPF/CNPJ válido.', 'error');
        return;
      }
      identity = found;

      // Guarda o e-mail digitado mesmo antes de autenticar (visitante começando
      // login ou cadastro) — não sobrepõe um e-mail que já veio de login.
      if (found.type === 'email' && ApiWS.CustomerEmail) {
        ApiWS.CustomerEmail.set(found.value, { source: 'identify' });
      }

      if (continueBtn) continueBtn.disabled = true;
      setContinueLabel('Aguarde...');

      try {
        var body = {};
        body[found.field] = found.value;
        var data = await ApiWS.Calls.checkSignup(body);
        var fieldResult = data && data.record && data.record[found.field];

        if (fieldResult && fieldResult.exists) {
          revealPasswordStep();
        } else {
          if (config.onIdentityNew) config.onIdentityNew(found);
          return;
        }
      } catch (e) {
        if (config.onCheckIdentityError) {
          config.onCheckIdentityError(e);
        } else {
          setMsg('mainMsg', 'Erro de conexão. Tente novamente.', 'error');
        }
      } finally {
        if (continueBtn) continueBtn.disabled = false;
        if (step === 'identity') setContinueLabel('Continuar');
      }
    }

    async function doLogin() {
      var passInp = $('passwordInput');
      var continueBtn = $('continueBtn');
      var password = (passInp || {}).value || '';
      setMsg('mainMsg', '', '');

      if (!password) {
        setMsg('mainMsg', 'Informe sua senha.', 'error');
        return;
      }
      if (!identity) { goBackToIdentityStep(); return; }

      if (continueBtn) continueBtn.disabled = true;
      setContinueLabel('Aguarde...');

      try {
        var data = await ApiWS.Calls.login(identity.value, password);
        if (data.result === 'success' && data.record) {
          ApiWS.User.saveSession(data.record);
          if (ApiWS.CustomerEmail) ApiWS.CustomerEmail.set(
            (data.record.customer && data.record.customer.email) ||
              (identity.type === 'email' ? identity.value : ''),
            { source: 'login', authoritative: true }
          );
          if (config.onLoginSuccess) config.onLoginSuccess(data.record);
        } else {
          setMsg('mainMsg', data.message || 'E-mail/CPF ou senha inválidos.', 'error');
        }
      } catch (e) {
        setMsg('mainMsg', 'Erro de conexão. Tente novamente.', 'error');
      } finally {
        if (continueBtn) continueBtn.disabled = false;
        if (step === 'password') setContinueLabel('Entrar');
      }
    }

    // --- Login social (Google/Facebook) ---
    //
    // /auth-pass devolve not_found + email quando o cliente é novo. Aproveita a primeira
    // autorização para preencher o cadastro. Fechamento, erro ou sessão inválida não
    // iniciam outra autorização: um segundo popup sem clique poderia ser bloqueado e
    // acabar redirecionando a aba principal.
    function handleSocial(provider) {
      var label = SOCIAL_LOGIN_LABELS[provider] || provider;
      var loginUrl = buildSocialAuthUrl(provider);
      if (!loginUrl) return;

      setMsg('mainMsg', '', '');

      function handleSocialResult(data) {
        if (data && data.error) {
          var email = typeof data.email === 'string' ? data.email : '';
          if (data.error === 'not_found' && email && socialSignupFallback && config.onSocialSignupResolved) {
            config.onSocialSignupResolved(provider, { email: email });
            return;
          }
          setMsg('mainMsg', 'Login com ' + label + ' não concluído.', 'error');
          return;
        }
        checkSessionAndFinish();
      }

      async function checkSessionAndFinish() {
        try {
          var data = await ApiWS.Calls.session();
          if (data && data.ok && data.user) {
            if (ApiWS.User && ApiWS.User.saveSession) ApiWS.User.saveSession(data.user);
            if (ApiWS.CustomerEmail && data.user.email) ApiWS.CustomerEmail.set(
              data.user.email, { source: 'login', authoritative: true }
            );
            if (config.onLoginSuccess) config.onLoginSuccess(data.user);
            return;
          }
        } catch (e) {}
        setMsg('mainMsg', 'Login com ' + label + ' não concluído.', 'error');
      }

      openSocialPopup(loginUrl, 'ws-social-login', handleSocialResult, checkSessionAndFinish);
    }

    // --- Esqueci Senha: Passo 1 (enviar e-mail) ---

    async function handleForgotSend() {
      var email = ($('forgotEmail') || {}).value || '';
      setMsg('forgotMsg', '', '');

      if (!email) {
        setMsg('forgotMsg', 'Informe seu e-mail.', 'error');
        return;
      }

      setLoading('forgotSendBtn', true);

      try {
        // ApiWS.Calls._fetch() nunca rejeita a promise em erro HTTP (sempre normaliza pra
        // {result:'error', message, __httpStatus, ...} e resolve) — sem checar "result" aqui,
        // esse try/catch nunca pegava erro de API nenhum, e a tela avançava pro passo de
        // verificar código mesmo quando o e-mail nunca foi enviado de verdade (ver
        // handleVerifyCode logo abaixo, que já fazia essa checagem certa).
        var data = await ApiWS.Calls.forgotPassword(email);

        if (data.result !== 'success') {
          setMsg('forgotMsg', data.message || 'Não foi possível enviar o código. Tente novamente.', 'error');
          return;
        }

        forgotEmail = email;

        var verifyLabel = $('verifyEmailLabel');
        if (verifyLabel) verifyLabel.textContent = email;

        var codeInput = $('verifyCode');
        if (codeInput) codeInput.value = '';
        setMsg('verifyMsg', '', '');

        showScreen('screenVerify');
      } catch (e) {
        setMsg('forgotMsg', 'Erro de conexão. Tente novamente.', 'error');
      } finally {
        setLoading('forgotSendBtn', false);
      }
    }

    // --- Esqueci Senha: Passo 2 (verificar código) ---

    async function handleVerifyCode() {
      var code = ($('verifyCode') || {}).value || '';
      setMsg('verifyMsg', '', '');

      if (!code) {
        setMsg('verifyMsg', 'Informe o código recebido por e-mail.', 'error');
        return;
      }

      setLoading('verifyBtn', true);

      try {
        var data = await ApiWS.Calls.forgotPasswordVerify(forgotEmail, code);

        if (data.result === 'success' && data.record && data.record.reset_token) {
          resetToken = data.record.reset_token;

          var passInput = $('resetPassword');
          var passConfirmInput = $('resetPasswordConfirm');
          if (passInput) passInput.value = '';
          if (passConfirmInput) passConfirmInput.value = '';
          setMsg('resetMsg', '', '');

          showScreen('screenReset');
        } else {
          setMsg('verifyMsg', data.message || 'Código inválido ou expirado.', 'error');
        }
      } catch (e) {
        setMsg('verifyMsg', 'Erro de conexão. Tente novamente.', 'error');
      } finally {
        setLoading('verifyBtn', false);
      }
    }

    // --- Esqueci Senha: Passo 3 (nova senha) ---

    async function handleResetPassword() {
      var password = ($('resetPassword') || {}).value || '';
      var confirm = ($('resetPasswordConfirm') || {}).value || '';
      setMsg('resetMsg', '', '');

      if (!password) {
        setMsg('resetMsg', 'Informe a nova senha.', 'error');
        return;
      }
      if (password !== confirm) {
        setMsg('resetMsg', 'As senhas não coincidem.', 'error');
        return;
      }
      if (password.length < 6) {
        setMsg('resetMsg', 'A senha deve ter no mínimo 6 caracteres.', 'error');
        return;
      }

      setLoading('resetBtn', true);

      try {
        var data = await ApiWS.Calls.resetPassword(resetToken, password);

        if (data.result === 'success') {
          resetToken = '';

          var identityInp = $('identityInput');
          if (identityInp && forgotEmail) identityInp.value = forgotEmail;

          showScreen('screenMain');
          // A conta já foi confirmada nos passos anteriores — pula direto pra senha em
          // vez de rodar check-signup de novo.
          identity = forgotEmail ? { type: 'email', field: 'email', value: forgotEmail } : null;
          forgotEmail = '';
          if (identity) revealPasswordStep();
          setMsg('mainMsg', 'Senha alterada com sucesso! Faça seu login.', 'success');
        } else {
          setMsg('resetMsg', data.message || 'Não foi possível alterar a senha.', 'error');
        }
      } catch (e) {
        setMsg('resetMsg', 'Erro de conexão. Tente novamente.', 'error');
      } finally {
        setLoading('resetBtn', false);
      }
    }

    // --- Wiring (uma vez só) ---

    function init() {
      var titleEl = $('title');
      identityTitleText = titleEl ? titleEl.textContent : '';

      if (config.prefillIdentityFromQuery) {
        try {
          var val = new URLSearchParams(window.location.search).get(config.prefillIdentityFromQuery);
          var prefillInp = $('identityInput');
          if (val && prefillInp) prefillInp.value = val;
        } catch (e) {}
      }

      // Sem prefill por query string, usa o e-mail conhecido do visitante
      // (login/identificação/newsletter/contato anteriores neste navegador).
      try {
        var idInp = $('identityInput');
        if (idInp && !idInp.value && typeof ApiWS !== 'undefined' && ApiWS.CustomerEmail) {
          var knownEmail = ApiWS.CustomerEmail.get();
          if (knownEmail) idInp.value = knownEmail;
        }
      } catch (e) {}

      var continueBtn = $('continueBtn');
      if (continueBtn) {
        continueBtn.addEventListener('click', function () {
          if (step === 'identity') checkIdentityAndProceed();
          else doLogin();
        });
      }

      var identityInp = $('identityInput');
      if (identityInp) {
        identityInp.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && continueBtn) { e.preventDefault(); continueBtn.click(); }
        });
      }

      var passInp = $('passwordInput');
      if (passInp) {
        passInp.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' && continueBtn) { e.preventDefault(); continueBtn.click(); }
        });
      }
      bindPasswordToggle(passInp);
      bindPasswordToggle($('resetPassword'));
      bindPasswordToggle($('resetPasswordConfirm'));

      var googleBtn = $('googleBtn');
      if (googleBtn) googleBtn.addEventListener('click', function () { handleSocial('google'); });

      var facebookBtn = $('facebookBtn');
      if (facebookBtn) facebookBtn.addEventListener('click', function () { handleSocial('facebook'); });

      var changeLink = $('changeIdentityLink');
      if (changeLink) {
        changeLink.addEventListener('click', function (e) {
          e.preventDefault();
          goBackToIdentityStep();
        });
      }

      var forgotLink = $('forgotLink');
      if (forgotLink) {
        forgotLink.addEventListener('click', function (e) {
          e.preventDefault();
          var forgotEmailInput = $('forgotEmail');
          if (forgotEmailInput && identity && identity.type === 'email') forgotEmailInput.value = identity.value;
          setMsg('forgotMsg', '', '');
          showScreen('screenForgot');
        });
      }

      var forgotSendBtn = $('forgotSendBtn');
      if (forgotSendBtn) forgotSendBtn.addEventListener('click', handleForgotSend);

      var forgotBackBtn = $('forgotBackBtn');
      if (forgotBackBtn) forgotBackBtn.addEventListener('click', function () { showScreen('screenMain'); });

      var forgotEmailInput = $('forgotEmail');
      if (forgotEmailInput) {
        forgotEmailInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') handleForgotSend(); });
      }

      var verifyBtn = $('verifyBtn');
      if (verifyBtn) verifyBtn.addEventListener('click', handleVerifyCode);

      var verifyBackBtn = $('verifyBackBtn');
      if (verifyBackBtn) verifyBackBtn.addEventListener('click', function () { showScreen('screenForgot'); });

      var verifyCodeInput = $('verifyCode');
      if (verifyCodeInput) {
        verifyCodeInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') handleVerifyCode(); });
      }

      var resetBtn = $('resetBtn');
      if (resetBtn) resetBtn.addEventListener('click', handleResetPassword);

      ['resetPassword', 'resetPasswordConfirm'].forEach(function (key) {
        var el = $(key);
        if (el) el.addEventListener('keydown', function (e) { if (e.key === 'Enter') handleResetPassword(); });
      });
    }

    return {
      init: init,
      reset: resetToIdentityStep,
    };
  }

  window.WsIdentifyFlow = {
    create: create,
    // Exposto solto porque wsapi3-checkout-payment-page.js também usa em um campo de
    // senha fora do fluxo de identificação (o "crie uma senha" do formulário de cadastro
    // no acordeão) — sem isso ele precisaria da própria cópia de EYE_ICON/EYE_OFF_ICON.
    bindPasswordToggle: bindPasswordToggle,
  };
})();
